import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accessToken: '',
  refreshToken: '',
  access_token: '',
  refresh_token: '',
  rb_ac_exp: 0,
  rb_rf_exp: 0,
  sessionKey: '',
  display: '',
  activeSession: null,
  isLogin: false,
  loading: true,
  fetching: false,
  isRefreshing: false,
  initialized: false,
  error: null,
  id: null,
  email: '',
  is_superuser: false,
  group: '',
  user_role: '',
  plant_id: '',
  factory: '',
  line: '',
  bu: '',
  hasSeededProfile: false,
  myApps: [],
};

const ALLOWED = new Set([
  'accessToken','refreshToken',
  'access_token','refresh_token','rb_ac_exp','rb_rf_exp',
  'sessionKey','display','activeSession',
  'isLogin','loading','fetching','isRefreshing','initialized','error',
  'id','email','is_superuser','group','user_role','plant_id','factory','line','bu',
  'hasSeededProfile','myApps'
]);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setState: (state, action) => {
      const next = action.payload || {};
      for (const k of Object.keys(next)) {
        if (ALLOWED.has(k)) state[k] = next[k];
      }
      if (!state.initialized) state.initialized = true;
    },
    setSessionKey: (state, action) => {
      state.sessionKey = action.payload || '';
    },
    resetAuth: (state) => {
      Object.assign(state, { ...initialState, loading: false, initialized: true });
      try { localStorage.removeItem('rb_tokens_v1'); } catch {}
    },
  },
});

export const { setState, setSessionKey, resetAuth } = authSlice.actions;
export default authSlice.reducer;
